<template>
  <el-card class="box-card">
    <div slot="header" class="header">通话成功率</div>
    <el-row :gutter="20">
      <el-col :span="4">
        <span>渠道</span>

        <el-select
          v-model="channelSelect"
          placeholder="请选择"
          @change="lifeCycleChannelChange"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, index) in lifeCycleChannel"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4"
        ><el-date-picker
          v-model="dateValue"
          value-format="yyyy-MM-dd"
          disabledDate="disabledDate"
          type="date"
          :picker-options="pickerOptions"
          placeholder="选择日期"
        >
        </el-date-picker
      ></el-col>

      <el-col :span="2"
        ><el-button type="primary" @click="getList">查询</el-button></el-col
      >
    </el-row>
    <el-table :data="tableList" style="width: 100%">
      <el-table-column prop="channel" label="渠道"> </el-table-column>

      <el-table-column prop="requestCount" label="通话请求数" sortable>
      </el-table-column>
      <el-table-column prop="successCount" label="通话扣费数" sortable>
      </el-table-column>
      <el-table-column prop="successRate" label="通话成功率"> </el-table-column>

      <el-table-column prop="successRate2" label="通话成功率2">
      </el-table-column>
    </el-table>
    <!-- <el-pagination
			background
			@current-change="handleCurrentChange"
			:current-page="currentPage"
			:page-size="tableList.length"
			layout="total, prev, pager, next, jumper"
			:total="tableList.length"
		></el-pagination> -->
  </el-card>
</template>

<script>
import { datainfor } from '@/utils/formdata.js'

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(date) {
          let dateNow = new Date()
          dateNow.setDate(dateNow.getDate() - 1)
          if (date.getTime() > dateNow.getTime()) {
            return true
          }
        }
      },
      dateValue: datainfor(1),
      currentPage: 1,
      loading: true,
      lifeCycleChannel: this.$store.state.channels,
      tableList: [],
      channelSelect: ['all']
    }
  },
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    lifeCycleChannelChange(currentVal) {
      const currentValLen = currentVal.length
      if (currentValLen !== 1) {
        if (
          currentVal[currentValLen - 1] === 'total' ||
          currentVal[currentValLen - 1] === 'all'
        ) {
          this.channelSelect = [currentVal[currentValLen - 1]]
        }
      }

      if (currentValLen === 2) {
        if (currentVal[0] === 'total' || currentVal[0] === 'all') {
          this.channelSelect = [currentVal[currentValLen - 1]]
        }
      }
    },
    datePickedChange(date) {
      this.datePicked = date
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    //用户生命周期数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.chat_successRate,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.dateValue,
          channel: this.channelSelect.join(',')
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableList = res.data.data
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style  lang='stylus'>
.box-card {
  margin: 20px;
  min-width: 1000px;

  .header {
    font-size: 28px;
    font-weight: bold;
  }

  .cell {
    text-align: center;
  }

  .el-row {
    margin-bottom: 20px;
  }

  .el-pagination {
    margin-top: 20px;
  }

  .el-col {
    display: flex;
    align-items: center;

    >span {
      display: inline-block;
      margin: 0 10px;
      white-space: nowrap;
      font-size: 13px;
    }
  }
}
</style>
